import React from "react";
import './style.scss';
import {EventType} from "../../../redux/reducers/contents/sample-data/events";
import {useDispatch} from "react-redux";
import {clearEvent} from "../../../redux/reducers/contents";

interface NotificationItemProps {
    id: string,
    objectID: string,
    type: EventType,
    time: string,
}

const NotificationItem: React.FC<NotificationItemProps> = (props) => {

    const dispatch = useDispatch();

    return (
        <div
            className={'notification-item d-flex flex-column p-2 mb-2 rounded align-items-center ' + props.type}
        >
            <h6>
                {props.type === EventType.PowerEvent ?
                    <i className="fa-solid fa-circle-exclamation me-2"></i> :
                    props.type === EventType.TemperatureAlert ?
                        <i className="fa-solid fa-exclamation me-2"></i>:
                        <i className="fa-solid fa-triangle-exclamation me-2"></i>
                }
                <b>
                    {props.type.replace('-', ' ').toUpperCase()}
                </b>
            </h6>
            <h6>Name: {props.objectID}</h6>
            <h6>Since: {props.time}</h6>
            <div className='w-100 d-flex flex-row justify-content-end'>
                <i className="action-btn fa-solid fa-eye me-3"
                   onClick={() => {
                       // @ts-ignore
                       window.v3d.puzzles.procedures.zoomTo('canh.' + props.objectID.substring(props.objectID.length - 3))
                   }}
                ></i>
                <i className="action-btn fa-solid fa-xmark"
                    onClick={() => {
                        dispatch(clearEvent(props.id))
                    }}
                ></i>
            </div>
        </div>
    )
}

export default NotificationItem
